import axios from 'axios';

const { apiHost = '' } = window.chatventasConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

export default wootAPI;
